import React from 'react';
import { Alert } from 'react-bootstrap';
import style from './UnauthorizedBanner.scss';

export default ({ children }) => (
  <Alert variant="info" className={style.unauthorized}>
    {children}
  </Alert>
);
